// extracted by mini-css-extract-plugin
export default {"nav":"BasePage_nav__nhsjb"};